import actionTypes from '../actionTypes';

export function successMessages(arrMessages: any[]) {
  return {
    type: actionTypes.GET_MESSAGES_SUCCESS,
    arrMessages
  };
}

export function requestReadMessage(messageId: any) {
  return {
    type: actionTypes.READ_MESSAGE_REQUEST,
    messageId,
  }
}

export const racePointsUpdated = (data: any) => ({
  type: actionTypes.SAVE_TEMPLATE_MSG_SUCCESS,
  payload: data,
});

